<template>
  <div class="input-label" :style="style">
    {{ value }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InputLabel',
  props: {
    value: {
      type: String,
      required: true,
    },
    marginBottom: {
      type: String,
      default: '0',
    },
    fontSize: {
      type: String,
      default: '16',
    },
  },
  computed: {
    style() {
      return {
        marginBottom: `${this.marginBottom}px`,
        fontSize: `${this.fontSize}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.input-label {
  font-weight: bold;
  color: #4F606B;
}
</style>
